module.exports = __webpack_public_path__ + "img/pre-university-campus-life.94017746.png";